import React, { useRef, useState, useEffect } from 'react';

const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

const ResizablePanels = ({
  left,
  center,
  right,
  initialLeftWidth = 190,
  minLeftWidth = 20,
  maxLeftWidth = 400,
  initialRightWidth = 600,
  minRightWidth = 20,
  maxRightWidth = 800,
  style = {},
}) => {
  const [leftWidth, setLeftWidth] = useState(initialLeftWidth);
  const [rightWidth, setRightWidth] = useState(initialRightWidth);
  const dragging = useRef(null); // 'left' or 'right'

  // Mouse event handlers
  const onMouseDown = (panel) => (e) => {
    dragging.current = {
      panel,
      startX: e.clientX,
      startLeftWidth: leftWidth,
      startRightWidth: rightWidth,
    };
    document.body.style.cursor = 'ew-resize';
    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
  };

  const onMouseMove = (e) => {
    if (!dragging.current) return;
    const { panel, startX, startLeftWidth, startRightWidth } = dragging.current;
    if (panel === 'left') {
      const newWidth = clamp(startLeftWidth + e.clientX - startX, minLeftWidth, maxLeftWidth);
      setLeftWidth(newWidth);
    } else if (panel === 'right') {
      const newWidth = clamp(startRightWidth - (e.clientX - startX), minRightWidth, maxRightWidth);
      setRightWidth(newWidth);
    }
  };

  const onMouseUp = () => {
    dragging.current = null;
    document.body.style.cursor = '';
    window.removeEventListener('mousemove', onMouseMove);
    window.removeEventListener('mouseup', onMouseUp);
  };

  // Update CSS variable for left panel width
  useEffect(() => {
    document.body.style.setProperty('--left-panel-width', leftWidth + 'px');
  }, [leftWidth]);

  return (
    <div style={{ display: 'flex', width: '100%', height: '100%', ...style }}>
      {/* Left Panel */}
      <div style={{ width: leftWidth, minWidth: minLeftWidth, maxWidth: maxLeftWidth, height: '100%', background: 'transparent', padding: 0, position: 'relative', overflow: 'hidden' }}>
        {left}
        {/* Divider */}
        <div
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            width: 6,
            height: '100%',
            cursor: 'ew-resize',
            zIndex: 10,
            background: 'transparent',
            borderRadius: "20px",
            borderRight: '1px solid rgba(255, 255, 255, 0.1)'
          }}
          onMouseDown={onMouseDown('left')}
        />
      </div>
      {/* Center Panel */}
      <div style={{ flex: 1, overflow: 'hidden', border: 'none', outline: 'none', height: '100%' }}>
        {center}
      </div>
      {/* Right Panel */}
      <div style={{ width: rightWidth, minWidth: minRightWidth, maxWidth: maxRightWidth, height: '100%', background: 'transparent', padding: 0, position: 'relative', overflow: 'hidden' }}>
        {/* Divider */}
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: 6,
            height: '100%',
            cursor: 'ew-resize',
            zIndex: 10,
            background: 'transparent',
            borderRadius: "20px",
            borderLeft: '1px solid rgba(255, 255, 255, 0.1)'
          }}
          onMouseDown={onMouseDown('right')}
        />
        {right}
      </div>
    </div>
  );
};

export default ResizablePanels; 